import DomComponent from "../../lib/domComponent";
/**
 * Loads the IFrame Player API async
 */
export default class  YoutubeVideoApi extends DomComponent{
    static selector = '[data-js-yt-video]';
    constructor(el){
        super(el);
        switch(window.settings.videoPlatform) {
            case 'Youku':
                this.video.setAttribute(
                    "src",
                    `https://player.youku.com/embed/${videoId}`
                );
                break;
            default: // YouTube.
                // 1. Verify if the tag already exists
                let tags = document.getElementsByTagName('script');
                if(!Array.from(tags).some(s => s.src == "https://www.youtube.com/iframe_api")){
                    // 2. This code loads the IFrame Player API code asynchronously.
                    var tag = document.createElement('script');
                    tag.src = "https://www.youtube.com/iframe_api";
                    var firstScriptTag = tags[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                }
                break;
        }

    }
}
